import React from 'react';
import { useForm } from 'react-hook-form';

import ModalHeader from '@components/modals/ModalHeader/ModalHeader';
import Button from '@components/uikit/Button/Button';
import Checkbox from '@components/uikit/Checkbox/Checkbox';

import useTranslation from '@hooks/useTranslation';

import { useModalActions } from '@store/useModalStore';

import style from './style.module.scss';

const tagsRegs = {
  openBold: '<b>',
  closeBold: '</b>',
  supportLink: '<a href="mailto:support@waites.net" class="btn-link support-link">support@waites.net</a>',
};

const ReplaceSensorMisConfirmModal = ({ onForceSubmit }) => {
  const { t } = useTranslation();

  const { setSecondaryModalClose } = useModalActions();

  const { control, watch } = useForm({ defaultValues: { confirmSubmit: false } });

  const confirmSubmitValue = watch('confirmSubmit');

  const handleClose = () => {
    setSecondaryModalClose();
  };

  return (
    <div className={style.misConfirmModal}>
      <ModalHeader />
      <div className={style.modalBody}>
        <div className={style.confirmText}>
          <div
            dangerouslySetInnerHTML={{
              __html: t(
                '{openBold}WARNING:{closeBold} You are attempting to replace this sensor with one that is not certified for hazardous environments. Using the incorrect sensor type in this environment may cause fire or explosion hazards. Please contact {supportLink} before continuing.',
                tagsRegs,
              ),
            }}
          />
          <div className={style.checkboxWrapper}>
            <Checkbox
              name="confirmSubmit"
              control={control}
              label={'I understand the risk. Continue with replacement.'}
            />
          </div>
        </div>
      </div>
      <div className={style.modalFooter}>
        <Button
          type="primary"
          text={t('Confirm')}
          disabled={!confirmSubmitValue}
          onClick={onForceSubmit}
        />
        <Button type="secondary" text={t('Cancel')} onClick={handleClose} />
      </div>
    </div>
  );
};

export default ReplaceSensorMisConfirmModal;
